<button
    class="btn btn-danger"
    [disabled]="states.isCollectingForbidden"
    (click)="cancel()"
>
    <i class="fa fa-undo"></i>{{ 'common.cancel' | translate }}
</button>
